// extracted by mini-css-extract-plugin
module.exports = {"containerBox":"styles_containerBox__360II","primary":"styles_primary__1sECH","secondary":"styles_secondary__1qxT-","third":"styles_third__1t7X0"};